<template>
  <div class="box-second">
      <p class="title-crumb">
          <el-breadcrumb separator-class="el-icon-arrow-right color3">
              <el-breadcrumb-item>工程审批</el-breadcrumb-item>
              <el-breadcrumb-item>审批人员管理</el-breadcrumb-item>
          </el-breadcrumb>
      </p>
      <div class="main">
          <div class="main-left">
              <el-tree :data="dataTree" ref="tree" :props="defaultProps" @node-click="handleNodeClick" node-key='id' highlight-current default-expand-all></el-tree>
          </div>
          <div class="main-table">
              <div class="table-head">
                <div style="width:100%;display:flex;align-items:center;">
                  <span>姓名：</span>
                  <div style="width:12vw;">
                    <el-input placeholder="请输入姓名" v-model="search.name"></el-input>
                  </div>
                  <span style="margin-left:1vw;">手机号码：</span>
                  <div style="width:12vw;">
                    <el-input placeholder="请输入手机号码" v-model="search.phone"></el-input>
                  </div>
                  <el-button type="primary" style="margin-left:1vw;" icon="el-icon-search" @click="doFilter">查询</el-button>
                  <el-button type="primary" style="margin-left:1vw;" class="add-user" @click="peosomExport">人员添加</el-button>                                
                </div>   
            
              </div>
              <div class="table-box">
                <el-table
                :data="listData"
                border
                height="100%"
                style="width: 100%;"
              >
                <template slot="empty">
                  <p>{{dataText}}</p>
                </template>
                <el-table-column label="序号">
                  <template slot-scope="scope">
                    <a>{{ scope.row.index}}</a>
                  </template>
                </el-table-column>     
                <el-table-column label="姓名">
                  <template slot-scope="scope">
                    <a>{{ scope.row.name}}</a>
                  </template>
                </el-table-column>     
                <el-table-column label="手机号码">
                  <template slot-scope="scope">
                    <span>{{ scope.row.username }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="单位">
                  <template slot-scope="scope">
                    <span>{{ scope.row.unitName }}</span>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="性别">
                  <template slot-scope="scope">
                    <span v-if="scope.row.sex=='1'">男</span>
                    <span v-else>女</span>
                  </template>
                </el-table-column> -->
                <el-table-column label="岗位">
                  <template slot-scope="scope">
                    <span>{{ scope.row.postName }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.useFlag==1" style="color:#86A0F3">在职</span>
                    <span v-else style="color:#FF5722;">离职</span>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="上传登录时间">
                  <template slot-scope="scope">
                    <span v-if="scope.row.useFlag==1" style="color:#86A0F3">{{scope.row.loginTime}}</span>
                    <span v-else style="color:#FF5722;">{{scope.row.createDate}}</span>
                  </template>
                </el-table-column> -->
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    <el-button v-if="scope.row.useFlag==1" size="mini" type="danger" @click="quitFun(0,scope.row)">离职</el-button>
                    <el-button v-else size="mini" type="success" @click="quitFun(1,scope.row)">入职</el-button>
                    <!-- <el-button size="mini" type="primary" @click="handleAutor(scope.$index, scope.row)">角色</el-button> -->
                  </template>
                </el-table-column>
              </el-table>
                  <!-- 分页展示 -->
                  <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page="currentPage"
                      :page-sizes="[20, 50, 100, 200]"
                      :page-size="pageSize"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="totalItems"
                      style="padding-top:10px;"
                  ></el-pagination>             
              </div>
          </div>
            <!-- 新增窗口 -->
    <el-dialog
    :title="dialogTitle"
    :visible.sync="addFormVisible"
    center
    width="500px"
    append-to-body
    class="add-form"
  >
    <el-form :model="addForm" :rules="rules" label-width="120px" ref="addForm">
      <el-form-item label="手机号码" prop="phone">
        <el-input v-if="addForm.id==''" v-model="addForm.phone" ></el-input>
        <el-input v-else v-model="addForm.phone" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input v-model="addForm.name"></el-input>
      </el-form-item>
      <el-form-item label="单位">
        <el-select v-model="addForm.unitId" placeholder="请选择" @input="change($event)" @change="floorSel"
        @clear="floorClear" clearable filterable>
        <el-option v-for="item in unitList" :key="item.id" :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
      </el-form-item>
      <el-form-item label="岗位">
        <el-select v-model="addForm.postId" placeholder="请选择" @input="change($event)" clearable filterable>
          <el-option v-for="item in postList" :key="item.id" :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="性别">
        <el-radio-group v-model="addForm.sex">
          <el-radio  label="1">男</el-radio>
          <el-radio label="0">女</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <el-form-item label="权限选择：" prop="list">
        <el-checkbox-group v-model="addForm.list">
          <el-checkbox v-for="item in authList" :key="item.id" :label="item.id">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="addFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
    </div>
  </el-dialog>
  <!-- 人员授权 -->
  <el-dialog
    width="40%"
    title="管理授权"
    :append-to-body="true"
    :lock-scroll="false"
    :visible.sync="authVisible"
    >
    <el-form ref="auth" :model="auth" label-width="120px" :rules="rulesAuth">
      <el-form-item label="活动名称：">
        <el-input v-model="auth.name" readonly style="width: 200px;"></el-input>
      </el-form-item>
      <el-form-item label="手机号码：" required prop="phone">
        <el-input v-model="auth.phone" style="width: 200px;"></el-input>
      </el-form-item>
      <el-form-item label="权限选择：">
        <el-checkbox-group v-model="auth.list">
          <el-checkbox v-for="item in authList" :key="item.id" :label="item.id">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button @click="authVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbitAuth('auth')">确 定</el-button>
    </div>
  </el-dialog>
      </div>
  </div>
</template>
<script>
  import myHttp from "../../../untils/port.js";
  import util from "../../../untils/util.js"
  import base from '../../../untils/base'
  export default {
    data() {
      var validatePhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入手机号码'));
        } else if(!(/^1[3456789]\d{9}$/.test(value))){
          callback(new Error('请输入正确的手机号码'));
        }else {
          callback();
        }
      };
      return {
        search:{  //查询
          phone:'',
          name:'',
          groupId:'',
          userType:'',
          unitId:'',
          postId:''
        },
        listData:[], //表格数据
        addForm:{
          id:'',
          name:'',
          phone:'',
          list:[],//角色列表
          roleIds:'',
          unitId:'',
          postId:''
        },
        dialogTitle:'',
        addFormVisible:false,
        dataTree:[],//左侧班组树形结构
            defaultProps:{
                children: 'children',
                 label: 'name'
            },
        // entId:'',
        // uploadUrl:base.url+'/entPerson/importEntPerson',//上传地址
        // uploadHead:{
        //   accessToken:this.$store.state.token
        // },
        // uploadData:{
        //   userId:'',
        //   entId:''
        // },
        // deptList:[],//所有部门列表
        rules: {
          name: [
            { required: true, message: '请输入姓名', trigger: 'blur' }
          ],
          phone: [
            { validator: validatePhone, trigger: 'blur' }
          ],
          list:[
            {type: 'array', required: true, message: '请选择角色', trigger: 'change' }
          ]
        },
        authVisible:false,//授权弹出框
        auth:{
          list:[],   //授权列表
          name:'',
          phone:'',
        },
        authList:[],//权限列表
        rulesAuth:{
          phone:[
            { required: true, message: '请输入手机号码', trigger: 'change' }
          ]
        },
        dataText:'数据加载中...',
        groupId:'',
        unitList:[],
        postList:[],
        unitListSearch:[],
        postListSearch:[],
        currentPage: 1, // 表单列表默认页
        pageSize: 20, // 表单列表默认显示数
        totalItems: 0, // 表单列表全部长度
        curKey:''
      }
    },
    mounted(){
      this.groupId = util.session.get('groupId')
      this.search.groupId = this.groupId;
      var role= util.session.get('roleId');
      if(role==4){
        this.search.groupType =2
        this.search.userType = 4
      }else if(role==5){
        this.search.groupType =1
        this.search.userType = 5
      }
      this.getTree()
      // this.getData();
      this.getSup();
     
      // this.uploadData.userId = this.$store.state.user.id;
      // this.uploadData.entId = this.entId;
      // this.getOfficeList();
    },
    methods: {
       /***
         * 获取侧边树
         */
         getTree(){
            var that = this
            myHttp.findSysUnitListLinkSide({
               groupId: this.groupId,
               groupType:this.search.groupType
            }).then(function(resp) {
                if (resp.data.code == '200') {
                  // console.log(resp)
                    var list = resp.data.data || []
                    var tree = util.common.listToTree('id', 'parentId', list)
                    var obj = [{ name: '全部', id: '0',  children: [] }]
                    obj[0].children = tree
                    that.dataTree = obj
                    that.curKey = 0
                    that.getData()
                    setTimeout(function(){
                      that.$refs.tree.setCurrentKey(that.curKey)
                    },100)
                }
            })
        },
         //点击树
         handleNodeClick(data){
            // console.log(data)
            if(data.type == '1'){
              this.search.unitId = data.id
              this.search.postId = ''
            }else if(data.type == '2'){
              // this.search.entId = ''
              this.search.postId = data.id
            }else {
              this.search.unitId = ''
              this.search.postId = ''
            }
            this.currentPage = 1
            this.getData()
        },
      // 搜索数据
      doFilter() {
        this.getData()
      },
      // 获取数据
      getData() {
        var that = this; 
        this.search.pageNum=this.currentPage,
        this.search.pageSize=this.pageSize,
        myHttp.getRoleUserListPage(this.search).then(function(resp){
          if(resp.data.code=="200"){
              var list = resp.data.data.users.list||[];
              for(var i=0;i<list.length;i++){
                 list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
               }      
              that.listData = list;
              if(that.listData.length==0){
                  that.dataText = "暂无数据"
              }
            that.totalItems =  resp.data.data.users.total
          }else{
            that.$message.error(resp.data.msg);
            that.dataText = "暂无数据"
          }
        },function(){});
      },
      //获取部门
      // getOfficeList(){
      //   var that = this;
      //   myHttp.getOfficeList({
      //     entId:this.entId
      //   }).then(function(resp){
      //     if(resp.data.code=="200"){
      //       // that.deptList = resp.data.data||[];
      //       var list = resp.data.data||[];
      //       that.deptList = list;
      //     }
      //   });
      // },
      //修改
      handleEdit(index,row){
        this.dialogTitle = "修改人员信息";
        this.addFormVisible = true;
        this.getSup()
        this.floorSel(row.unitId)
        this.addForm.id = row.id;
        this.addForm.userId = row.id;
        this.addForm.name = row.name;
        this.addForm.roleIds = '';
        this.addForm.phone = row.username;
        this.addForm.unitId = row.unitId;
        this.addForm.postId = row.postId;
        // this.addForm.oleRoleIds = row.roleIds;
        // this.addForm.list = row.roleIds.split(',');
        this.getAllRole(true,row)
      },
      //保存
      sumbitAddRow(formName){
        var that = this;
        this.$refs[formName].validate((valid) => {
            if (valid) {
              //that.addForm.groupId = that.groupId;
              that.addForm.roleIds = that.addForm.list.join(',');
              that.addForm.groupId = that.groupId
              that.addForm.groupType = that.search.groupType
              if(that.addForm.id==''){
                myHttp.createProUser(that.addForm).then(function(resp){
                  if(resp.data.code=="200"){
                    that.$message.success('添加人员成功');
                    that.addFormVisible = false;
                    that.getData();
                  }else{
                    that.$message.error(resp.data.msg);
                  }
                });
              }else{
                that.addForm.roleIds = that.addForm.list.join(',');
                myHttp.updateProUser(that.addForm).then(function(resp){
                  if(resp.data.code=="200"){
                    that.$message.success('修改人员成功');
                    that.addFormVisible = false;
                    that.getData();
                  }else{
                    that.$message.error(resp.data.msg);
                  }
                });
              }
            }
        });
      },
      //导出
      exportOut(){
        window.open(base.httpCtx+'/wisdom/template/entPerson.xlsx');
      },
      //人员添加
      peosomExport(){
        this.dialogTitle = "添加人员信息";
        this.addFormVisible = true;
        this.addForm = {
          id:'',
          name:'',
          phone:'',
          list:[],//角色列表
          roleIds:'',
        },
        this.getAllRole(false)
      },
      //上传成功监听方法
      handleAppSuccess(res,file){
        if(res.code=='200'){
          this.$message.success('上传成功');
        }else{
          this.$message.error(res.msg);
        }
      },
      //部门改变
      officeChange(){
        this.$forceUpdate()
      },
      //根据手机号获取信息
      getInfoByPhone(phone){
        //console.log(phone);
        if(phone=='')return;
        var that = this;
        myHttp.getInfoByPhone({
          phone:phone
        }).then(function(resp){
          if(resp.data.code=="200"){
            var data = resp.data.data.person;
            if(data&&data.id&&''!=data.id){
              that.addForm.id = data.id;
              that.addForm.name = data.name;
              that.addForm.phone = data.phone;
            }
          }
        });
      },
      //获取角色信息
      getAllRole(flag,row){
        var that = this;
        //myHttp.getRoleListByGroupId({
        myHttp.getRoleByGroup({
          groupId:this.groupId,
          userType: util.session.get('roleId'),
          userId:util.session.get('user').id
        }).then(function(resp){
          if(resp.data.code=="200"){
            var list = resp.data.data.role||[];
            that.authList = list;
            if(flag){
              that.getWorkerAuth(row.id);
            }
          }else{
            that.$message.error(resp.data.msg);
          }
        });
      },
      //人员授权
      handleAutor(index,row){
        this.authVisible = true;
        this.auth.name = row.personName;
        this.auth.phone = row.phone;
        this.auth.personId = row.personId;
        this.auth.list = [];
        this.getAllRole(true,row)
      },
      //获取当然人员的权限
      getWorkerAuth(id){
        var that = this;
        myHttp.getRoleListByUserId({
          userId:id,
          userType:util.session.get('roleId'),
          groupId:this.groupId
        }).then(function(resp){
          if(resp.data.code=="200"){
            var list = resp.data.data.roleList||[];
            var list1 = [];
            for(var i=0;i<list.length;i++){
              list1.push(list[i].id);
            }
            that.addForm.oldRoleIds = list1.join(',');
            that.addForm.list = list1;
            //that.auth.list = list1;
          }
        });
      },
      //授权保存
      sumbitAuth(formName){
        var that = this;
        this.$refs[formName].validate((valid) => {
            if (valid) {
              var option = {};
              option.projectId = that.search.entId;
              option.userType = that.$store.state.roleId;
              option.roleIds = that.auth.list.length>0?that.auth.list.join(','):'';
              option.phone = that.auth.phone;
              option.name = that.auth.name;
              option.personId = that.auth.personId;
              myHttp.authorizePerson(option).then(function(resp){
                if(resp.data.code=="200"){
                  that.authVisible = false;
                  that.$message.success('授权成功');
                  that.getData();
                }else{
                  that.$message.error(resp.data.msg);
                }
              });
            }
          });
      },
      //离职或者在职
      quitFun(sta,row){
        var that = this
        myHttp.updateProUseFlag({
          userId:row.id,
          useFlag:sta
        }).then(function(resp){
          if(resp.data.code=='200'){
            that.$message.success('操作成功')
            that.getData()
          }else{
            that.$message.error('操作失败')
          }
        })
      },
       // 查询供应商
       getSup() {
          var that = this
          myHttp.findSysUnitListLinkSide({
               groupId: this.groupId,
               groupType:this.search.groupType
            }).then(function (resp) {
            if (resp.data.code == '200') {
              var list = resp.data.data
              that.unitList = list
              that.unitListSearch = list
            }
          })
        },
         //监听供应商下拉框
         floorSel(e) {
          this.doFilter()
          this.getSup()
          for (var i = 0; i < this.unitList.length; i++) {
            if (e == this.unitList[i].id) {
              // console.log(i)
              this.postList = this.unitList[i].children
            }
          }
        },
          //监听供应商下拉框
          floorSel1(e) {
          this.doFilter()
          this.getSup()
          for (var i = 0; i < this.unitListSearch.length; i++) {
            if (e == this.unitListSearch[i].id) {
              // console.log(i)
              this.postListSearch = this.unitListSearch[i].children
            }
          }
        },
        //监听供应商下拉框清空
        floorClear() {
          this.unitList = []
          this.postList = []
          this.addForm.unitId = ''
          this.addForm.postId = ''
          this.doFilter()
        },
        floorClear1() {
          this.unitListSearch = []
          this.postListSearch = []
          this.search.unitId = ''
          this.search.postId = ''
          this.doFilter()
        },
        handleSizeChange(val) {
        this.pageSize = val
        this.handleCurrentChange(this.currentPage)
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getData()
      },
      // 监控当前页码
      currentChangePage() {
        this.getData()
      },
      change(e){
        
      }
    }
  }
  </script>
<style scoped>
  /* .box-second{
      width: 100%;
      height: 100%;
      position: relative;
  }
  .title{
      width: 100%;
      height: 3vh;
      position: relative;
      display: flex;
      align-content: center;
      align-items: center;
      padding-left: 1vw;
  }
  .main{
      width: 100%;
      height: calc( 100% - 3vh );
      position: relative;
      display: flex;
      padding: 0 1vw 0.5vw;
  } */
  .box-second .main{
    height: calc(100% - 38px);
  }
  .main-left{
      width: 15vw;
      height: 100%;
      position: relative;
      overflow: auto;
      background: #fff;
      border-radius: 0.5vh;
      padding: 2vh;
  }
  .main-table{
      width: calc( 100% - 15vw );
      height: 100%;
      position: relative;
      padding-left: 1vw;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
  }
  .table-head{
      width: 100%;
      /* height: 10vh; */
      position: relative;
      background: #fff;
      border-top-left-radius: 0.5vh;
      border-top-right-radius: 0.5vh;
      display: flex;
      flex-direction: column;
      align-content: center;
      align-items: center;
      padding: 2vh;
      /* justify-content: space-between; */
      background: #FAFAFA;
  }
  .table-head-seach{
      width: 10%;
      height: 100%;
      position: relative;
  }
  .table-box{
      width: 100%;
      height: calc( 100% - 16vh );
      position: relative;
      background: #fff;
      border-bottom-left-radius: 0.5vh;
      border-bottom-right-radius: 0.5vh;
      margin-top: 0.5vh;
  }
 .box-second  >>>.el-date-editor .el-range-separator{
    padding: 0 !important;
  }
  .box-second >>>.el-input-group--append .el-input__inner{
    width: 200px;
  }
  .tips{
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 14px;
   }
  /* .main-left .is-current{
    color: #048AFA;
  } */
</style>
<style>
@import '../../../assets/css/common.css'
</style>